export const iconFontAwesomeEditingPenToSquare = (
	<i className="fa-solid fa-pen-to-square"></i>
);
